import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import uuid from "react-uuid";

import { SvgComponent } from "components";
import ToolTip from "components/ToolTip/ToolTip";

/**
 * Popover for the "Otros" and "Imprimir" columns.
 *
 * Props:
 *   items: Array<{ funcion: Funcion, label: string }>
 *   handleFuncionSwitch: (IdSec, eventLike) => void
 *   iconName: name of the trigger icon (defaults to "more-horiz"; pass "print" for Imprimir)
 */
function PermisosOptions({ items, handleFuncionSwitch, iconName = "more-horiz" }) {
  const [showOptions, setShowOptions] = useState(false);
  const componentRef = useRef(null);
  const [uniqueId] = useState(uuid());

  const handleClickOutside = (event) => {
    if (
      componentRef.current &&
      !componentRef.current.contains(event.target) &&
      event.target.closest(`.accion-rapida-${uniqueId}`) === null
    ) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        ref={componentRef}
        className="accion-rapida"
        style={{
          cursor: "pointer",
          marginLeft: "10px",
          textAlign: "center",
          backgroundColor: "transparent",
        }}
        onClick={() => setShowOptions((prevValue) => !prevValue)}
      >
        <SvgComponent
          height="24px"
          width="24px"
          iconName={iconName}
          className="mr-2"
          fill={"gray"}
        />
      </div>
      {showOptions && (
        <div
          className={`d-flex flex-column position-absolute p-2 accion-rapida-${uniqueId}`}
          style={{
            backgroundColor: "rgb(248, 248, 248)",
            right: "9%",
            top: "15px",
            borderRadius: "5px",
            zIndex: 20,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            maxHeight: "30vh",
            overflow: "auto",
          }}
        >
          {items.map(({ funcion, label }) => {
            const check = (
              <Form.Check
                name={funcion.Nombre}
                style={{
                  width: "15px",
                  height: "15px",
                  marginTop: "2px",
                }}
                onChange={(e) => handleFuncionSwitch(funcion.IdSec, e)}
                checked={funcion?.EsAnadirPerfil === true}
              />
            );
            return (
              <div
                key={funcion.IdSec}
                className="p-2 d-flex align-items-center justify-content-between"
                style={{ borderRadius: "5px", gap: "10px" }}
              >
                <div className="d-flex align-items-center">
                  {funcion.Descripcion ? (
                    <ToolTip message={funcion.Descripcion}>{check}</ToolTip>
                  ) : (
                    check
                  )}
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      margin: "0px",
                      marginLeft: "10px",
                    }}
                  >
                    {label}
                  </p>
                </div>
                {funcion.Descripcion && (
                  <ToolTip message={funcion.Descripcion}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        backgroundColor: "#447DF7",
                        color: "#fff",
                        fontFamily: "serif",
                        fontStyle: "italic",
                        fontSize: "12px",
                        fontWeight: "bold",
                        cursor: "help",
                        flexShrink: 0,
                      }}
                    >
                      i
                    </span>
                  </ToolTip>
                )}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default PermisosOptions;
